import React, { useState, useEffect, useContext } from 'react';
import { EthDateTime } from 'ethiopian-calendar-date-converter';

import axiosInstance from '../../api';
import AppRegistrationInfo from './AppRegistrationInfo';
import { authContext } from '../../routes';
import SERVER_API_URL from '../../config';
import { ethMonthFormatter } from '../../utils/ethDateFormatter';

export default function RegistrationInfo() {
  const { user } = useContext(authContext);
  const [userList, setUserList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [userListIds, setUserListIds] = useState([]);

  const dioceseLevel = user && user.role.permissions.dioceseLevel.read;
  const districtLevel = user && user.role.permissions.districtLevel.read;

  useEffect(() => {
    const getAllCategory = async () => {
      try {
        const response = await axiosInstance.get(`${SERVER_API_URL}/category/findAll`);
        if (response.status === 200) {
          setCategoryList(response.data);
        }
      } catch (error) {
        // console.log(error);
      }
    };

    const getAllUsers = async () => {
      try {
        let response;
        if (dioceseLevel) {
          response = await axiosInstance.post(`${SERVER_API_URL}/user/findAllForDashboard`);
        } else if (districtLevel) {
          response = await axiosInstance.post(
            `${SERVER_API_URL}/user/findManyByDistrictId/${user && user.church.district.id}`
          );
        } else {
          response = await axiosInstance.post(`${SERVER_API_URL}/user/findManyByChurchId/${user && user.church.id}`);
        }

        if (response.status === 200) {
          setUserList(response.data);
          const usersId = [];
          response.data.forEach((user) => {
            usersId.push(user.id);
          });
          setUserListIds(usersId);
        }
      } catch (error) {
        // console.log(error);
      }
    };

    getAllUsers();
    getAllCategory();
  }, [dioceseLevel, districtLevel, user]);

  const ethiopianMonths = [
    'መስከረም', 'ጥቅምት', 'ህዳር', 'ታህሳስ', 'ጥር', 'የካቲት',
    'መጋቢት', 'ሚያዝያ', 'ግንቦት', 'ሰኔ', 'ሐምሌ', 'ነሐሴ', 'ጳጉሜ'
  ];
  
  const currentDate = new Date();
  const currentEthiopianDate = EthDateTime.fromEuropeanDate(currentDate);

  function formatAllMonths() {
    const ethiopianYear = currentEthiopianDate.year;
    return ethiopianMonths.map(month => `${month}, ${ethiopianYear}`);
  }
  
  const months = formatAllMonths();

  categoryList.forEach((category) => {
    category.users.forEach((user) => {
      if (userListIds.includes(user.id) && user.createdAt) {
        const europeanDate = new Date(user.createdAt);
        const ethiopianDate = EthDateTime.fromEuropeanDate(europeanDate);
        const newDate = ethMonthFormatter(ethiopianDate);
        user.formattedDate = newDate;
      }
    });
  });

  const barCategoryData = [];
  const barColors = [];
  categoryList.forEach((category) => {
    const data = new Array(months.length).fill(0);
    category.users.forEach((user) => {
      if (userListIds.includes(user.id) && user.formattedDate && months.includes(user.formattedDate)) {
        const monthIndex = months.indexOf(user.formattedDate);
        data[monthIndex] += 1;
      }
    });

    barCategoryData.push({
      name: category.name,
      type: 'line',
      fill: 'solid',
      data,
    });
    barColors.push(category.color);
  });

  const totalData = new Array(months.length).fill(0);

  categoryList.forEach((category) => {
    category.users.forEach((user) => {
      if (userListIds.includes(user.id)) {
        const userCreatedAt = user.formattedDate;
        if (months.includes(userCreatedAt)) {
          const monthIndex = months.indexOf(userCreatedAt);
          totalData[monthIndex] += 1;
        }
      }
    });
  });

  barCategoryData.push({
    name: 'አጠቃላይ',
    type: 'column',
    fill: 'solid',
    data: totalData,
  });

  barColors.push('#061B64');

  const currentYear = new Date().getFullYear();

  let newlyAddedUsersCount = 0;

  if (userList) {
    userList.forEach((user) => {
      const userYear = new Date(user.createdAt).getFullYear();
      if (userYear === currentYear) {
        newlyAddedUsersCount += 1;
      }
    });
  }

  const infoString = `(+${newlyAddedUsersCount}) በዚህ ዓመት አዲስ የተጨመሩ ተጠቃሚዎች።`;

  return (
    <AppRegistrationInfo
      title="የተከታዮች ምዝገባ መረጃ"
      subheader={infoString}
      chartColors={barColors}
      chartLabels={months}
      chartData={barCategoryData}
    />
  );
}
